function deferredPromise(resolveWith) {
    let res;
    const p = new Promise((resolve) => {
        if (typeof resolveWith === "function") {
            res = () => {
                resolve(resolveWith());
            };
        }
        else {
            res = async (args) => {
                resolve(args);
            };
        }
    });
    Object.defineProperty(p, "resolve", {
        value: res,
    });
    return p;
}
export { deferredPromise };
//# sourceMappingURL=deferred-promise.js.map